import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=cde8f37c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde8f37c')) {
      api.createRecord('cde8f37c', component.options)
    } else {
      api.reload('cde8f37c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=cde8f37c", function () {
      api.rerender('cde8f37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventorySystemManagement/supplier/edit.vue"
export default component.exports